import { render, staticRenderFns } from "./ConfirmAdmission.vue?vue&type=template&id=7f65d630"
import script from "./ConfirmAdmission.vue?vue&type=script&lang=js"
export * from "./ConfirmAdmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f65d630')) {
      api.createRecord('7f65d630', component.options)
    } else {
      api.reload('7f65d630', component.options)
    }
    module.hot.accept("./ConfirmAdmission.vue?vue&type=template&id=7f65d630", function () {
      api.rerender('7f65d630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/ConfirmAdmission.vue"
export default component.exports